import React, { useMemo } from 'react';
import { Select } from 'antd';
import { selectors, actions } from '../../../model';
import { useDispatch, useSelector } from 'react-redux';
import FormItem from '../../ui/FormItem/FormItem';
import { getReplacedString } from '../../../../../../../helpers/getReplacedString';

const { selectSettingStepValue, selectSettingStepError } = selectors;
const { settingFieldChangeAction } = actions;

const FieldWrapper = ({ name, label, required, children }) => {
  const errorsSelector = useMemo(
    () => (state) => selectSettingStepError(state, name),
    [name]
  );

  const errors = useSelector(errorsSelector);

  return (
    <FormItem
      required={required}
      label={label}
      errors={errors}
    >
      {children}
    </FormItem>
  );
};

const filterOption = (input, option) => {
  const target = getReplacedString(option.props.search);
  const search = getReplacedString(input);
  return target.includes(search);
};

const SettingStepMappingSelect = ({
  name,
  label,
  optional,
  columns,
  values,
}) => {
  const valueSelector = useMemo(
    () => (state) => selectSettingStepValue(state, name),
    [name]
  );

  const value = useSelector(valueSelector);

  const dispatch = useDispatch();
  const handleChange = (value) =>
    dispatch(settingFieldChangeAction({ name, value }));

  return (
    <FieldWrapper
      name={name}
      label={label}
      required={!optional}
    >
      <Select
        value={value}
        style={{ width: '100%' }}
        onChange={handleChange}
        allowClear
        showSearch={columns.length > 8}
        filterOption={filterOption}
      >
        {columns.map(({ 0: key, 1: name }) => (
          <Select.Option
            key={key}
            value={key}
            disabled={values.has(key)}
            search={`Столбец ${key}: ${name}`}
          >
            Столбец {key}: {name}
          </Select.Option>
        ))}
      </Select>
    </FieldWrapper>
  );
};

export default SettingStepMappingSelect;
